export default "__VITE_ASSET__IZh7bYuO__"